@if (ps.page(pageName) != null) {
  <form [formGroup]="ps.page(pageName)?.form">
    <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'person_firstname'}"></ng-container>
    <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'person_lastname'}"></ng-container>
    <br>
    <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'person_email'}"></ng-container>
    <!--    <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'person_phone'}"></ng-container>-->
    <br>
    <!--    <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'person_address1'}"></ng-container>-->
    <!--    <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'person_address2'}"></ng-container>-->
    <!--    <br>-->
    <!--    <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'person_zip'}"></ng-container>-->
    <!--    <ng-container *ngTemplateOutlet="formFieldTemplate; context: {name: 'person_city'}"></ng-container>-->
  </form>
  <button (click)="clickImgur($event)" mat-button>
    <span i18n>imgur</span>
    @if (!Utils.isEmpty(_data.person.imgur.at)) {
      <mat-icon>no_photography</mat-icon>
    } @else {
      <mat-icon>photography</mat-icon>
    }
  </button>
}
@if (ps.page(pageName) == null) {
  <div i18n page-error>
    The form is missing some information
  </div>
}
<ng-template #formFieldTemplate let-name="name">
  <mat-form-field [appearance]="ps.appearance" [formGroup]="ps.page(pageName).form">
    <mat-label>{{ ps.page(pageName).controls[name]?.label }}</mat-label>
    <input [formControlName]="name" [id]="name" matInput>
    <!-- mat-error *ngIf="form.get(name)?.invalid && !form.get(name)?.untouched">
      <ng-container *ngIf="form.get(name)?.errors?.['required']" i18n>{{ controls[name]?.label }} is required</ng-container>
      <ng-container *ngIf="form.get(name)?.errors?.['email']" i18n>Invalid email address</ng-container>
    </mat-error -->
  </mat-form-field>
</ng-template>
